<template>
  <div v-if="orderDetail" class="logistics-page">
    <div class="logistics-page-header c:row-center">{{ statusString }}</div>
    <div class="logistics-page-order">
      <div class="logistics-page-logistics c:row-between-center">
        <div class="logistics-page-logistics-company">
          {{ orderDetail.logisticsCompany }}
        </div>
        <div
          class="logistics-page-logistics-number c:row-end-center"
          v-clipboard:copy="orderDetail.logisticsNo"
          v-clipboard:success="onCopy"
        >
          <span>{{ orderDetail.logisticsNo }}</span>
          <img src="@/assets/icons/copy-dark.svg" alt="" />
        </div>
      </div>
      <div class="logistics-page-order-items">
        <div class="logistics-page-order-items-head c:row-between-center">
          <div class="logistics-page-order-items-label">
            {{ orderItemPics.length }} 件商品
          </div>
          <div class="logistics-page-order-items-amount">
            ¥
            {{ orderDetail.amount | filterPrice }}
          </div>
        </div>
        <div class="logistics-page-order-items-pics">
          <div class="logistics-page-order-items-pic-list c:row-start-center">
            <div
              v-for="(item, index) in orderItemPics"
              :key="index"
              class="logistics-page-order-items-pic c:row-center"
              :class="{ default: item.isDefaultUrl }"
              @click="preview(index)"
            >
              <img :src="item.src" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="routeInfo?.logisticsRouteInfoList?.length"
      class="logistics-page-routes"
    >
      <div
        v-for="(route, index) in routeInfo.logisticsRouteInfoList"
        :key="index"
        class="logistics-page-route-item"
      >
        <div class="logistics-page-route-status">
          {{ routeStatus[route.status] || "-" }}
        </div>
        <div class="logistics-page-route-desc">
          {{ route.description }}
        </div>
        <div class="logistics-page-route-time">
          {{ route.modifyTime | formatDateTime }}
        </div>
      </div>
    </div>
    <div v-else class="logistics-page-empty">等待物流更新</div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import {
  getCustomerOrderDetail,
  getEnumMap,
  getOrderDetailInWorkApi,
  getWeChatRouteInfo,
  getWxWorkRouteInfo,
} from "@/api";
import { mapState } from "vuex";
import { routeStatus } from "@/consts/logistics";
import normalPage from "@/mixins/normal-page";
// import orderDetail from "@/mock/data/order-detail";
// import routeInfo from "@/mock/data/route-info";

export default {
  mixins: [normalPage],
  data() {
    return {
      routeStatus,
      inited: false,
      orderStatusMap: {},
      orderDetail: null,
      routeInfo: null,
    };
  },
  computed: {
    ...mapState(["logisticsOrderDetail"]),
    // ...mapGetters(["runInWxWork", "runInWeChat"]),
    statusString() {
      if (this.routeInfo?.logisticsRouteInfoList?.length) {
        const lastStatus = this.routeInfo.logisticsRouteInfoList[0].status;
        switch (lastStatus) {
          case "ABNORMAL_FEEDBACK":
            return `物流信息异常`;

          case "CANCELED":
          case "DISPATCHING":
            return `物流${routeStatus[lastStatus]}`;

          case "OTHER":
            break;

          case "REJECT":
          case "SENDBACK_SUCCESS":
          case "SEND_ARRIVE":
          case "SEND_BACK":
          case "SEND_ON":
          case "SEND_OFF":
          case "SEND_SUCCESS":
            return `商品已${routeStatus[lastStatus]}`;

          case "SEND_FAIL":
          case "SIGN_FAIL":
            return `商品${routeStatus[lastStatus]}`;

          case "SEND_ING":
          case "SEND_PIECES":
            return `商品正在${routeStatus[lastStatus]}`;

          // case "RECEIVED_ORDER":
          default:
            return routeStatus[lastStatus];
        }
      }
      return this.inited
        ? `商品${this.orderStatusMap[this.orderDetail.status]}`
        : "";
    },
    orderItemPics() {
      return this.orderDetail.orderItems.map((item) => {
        const isDefaultUrl = !(item.productPicSmall || item.productPic);
        return {
          isDefaultUrl,
          src: isDefaultUrl
            ? this.$store.state.brandInfo.shareImage
            : item.productPicSmall || item.productPic,
        };
      });
    },
  },
  mounted() {
    getEnumMap("OrderStatusEnum").then((map) => {
      this.orderStatusMap = map;
      this.inited = true;
    });
    this.getOrderExpress();
  },

  methods: {
    async getOrderExpress() {
      const { orderId, orderNo } = this.$route.query;
      const reqs = [];
      if (this.runInWxWork) {
        reqs.push(getWxWorkRouteInfo(orderId).then((r) => r?.[0] || null));
        if (this.logisticsOrderDetail.id === orderId) {
          this.orderDetail = this.logisticsOrderDetail;
        } else {
          reqs.push(
            getOrderDetailInWorkApi(orderNo).then((d) => (this.orderDetail = d))
          );
        }
      } else if (this.runInWeChat) {
        reqs.push(getWeChatRouteInfo(orderId).then((r) => r?.[0] || null));
        if (this.logisticsOrderDetail.id === orderId) {
          this.orderDetail = this.logisticsOrderDetail;
        } else {
          reqs.push(
            getCustomerOrderDetail(orderNo).then((d) => (this.orderDetail = d))
          );
        }
      } else {
        return this.$router({ name: "Forbidden" });
      }

      try {
        this.$toast.loading({
          message: "加载中",
          forbidClick: true,
        });
        const [routeInfo] = await Promise.all(reqs);
        console.log("routeInfo", routeInfo);
        this.routeInfo = routeInfo;
        this.$toast.clear();
      } catch (error) {
        if (error?.message) this.$toast(error.message);
        else this.$toast.clear();
      }
    },
    preview(index) {
      ImagePreview(
        this.orderItemPics.map(({ src }) => src),
        index
      );
    },
    onCopy() {
      this.$toast("物流单号复制成功");
    },
  },
};
</script>
<style lang="less" scoped>
.logistics-page {
  &-header {
    width: 100%;
    height: 60/20rem;
    background-color: #f7f7f7;

    line-height: 22/20rem;
    font-weight: 500;
    font-size: 16/20rem;
    text-align: center;
    letter-spacing: 0;
    color: #000;
  }

  &-order {
    padding: 0 20/20rem;
    background-color: #fff;

    line-height: 12/20rem;
    font-weight: 500;
    font-size: 12/20rem;
    letter-spacing: 0;
    color: #000;

    &-items {
      padding: 20/20rem 0;

      &-head {
        height: 12/20rem;
        margin-bottom: 15/20rem;
      }

      &-pics {
        overflow-x: auto;
        overflow-y: hidden;
        &::-webkit-scrollbar {
          display: none;
        }
      }

      &-pic-list {
        flex-wrap: nowrap;
        gap: 8/20rem;

        width: max-content;
        height: 104/20rem;
      }

      &-pic {
        width: 80/20rem;
        height: 104/20rem;
        background-color: #fff;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain; /* 或者使用 contain */
        }
        &.default {
          // border: solid 0.5px #eee;
          img {
            max-width: 50%;
            max-height: 50%;
          }
        }
      }
    }
  }

  &-logistics {
    height: 52/20rem;
    border-bottom: solid 1/20rem #e8e8e8;

    &-number {
      img {
        width: 12/20rem;
        height: 12/20rem;
        margin-left: 6/20rem;
      }
    }
  }

  &-routes {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    padding: 20/20rem;
    border-top: solid 10/20rem #f7f7f7;
    background-color: #fff;
    .logistics-page-route-item {
      position: relative;
      box-sizing: border-box;
      margin-left: 9/20rem;
      padding-left: 24/20rem;
      padding-bottom: 40/20rem;
      border-left: 0.5/20rem solid #bfbfbf;
      overflow: visible;

      .logistics-page-route-status {
        width: 100%;
        height: 21/20rem;
        line-height: 21/20rem;
        font-size: 15/20rem;
        font-weight: 500;
        letter-spacing: 0;
        color: #999;
      }
      .logistics-page-route-desc {
        width: 100%;
        margin-top: 8/20rem;
        line-height: 18/20rem;
        font-size: 12/20rem;
        font-weight: 400;
        letter-spacing: 0;
        color: #999;
      }
      .logistics-page-route-time {
        width: 100%;
        margin-top: 10/20rem;
        line-height: 11/20rem;
        font-size: 11/20rem;
        font-weight: 400;
        letter-spacing: 0;
        color: #999;
      }

      &::before {
        content: "";
        position: absolute;
        display: block;
        width: 6/20rem;
        height: 6/20rem;
        background-color: #bfbfbf;
        border-radius: 3/20rem;
        top: 6/20rem;
        left: -3/20rem;
        transform: translateX(-0.5/20rem);
        z-index: 10;
      }

      &:first-child {
        .logistics-page-route-status {
          color: #1b1b1b;

          &::before {
            content: "";
            position: absolute;
            display: block;
            width: 4/20rem;
            height: 12/20rem;
            background-color: white;
            top: 0;
            left: -2/20rem;
          }
        }
        .logistics-page-route-desc,
        .logistics-page-route-time {
          color: #000;
        }
        &::before {
          width: 12/20rem;
          height: 12/20rem;
          background-color: #000;
          border-radius: 6/20rem;
          top: 5/20rem;
          left: -6/20rem;
        }
        &::after {
          content: "";
          position: absolute;
          display: block;
          box-sizing: border-box;
          width: 18/20rem;
          height: 18/20rem;
          border: solid 1/20rem #000;
          border-radius: 9/20rem;
          background-color: #fff;
          top: 2/20rem;
          left: -9/20rem;
          transform: translateX(-0.5/20rem);
          z-index: 5;
        }
      }

      &:last-child {
        padding-bottom: 10/20rem;
      }
    }
  }

  &-empty {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    padding: 20/20rem;
    border-top: solid 10/20rem #f7f7f7;
    background-color: #fff;

    line-height: 60/20rem;
    font-weight: 400;
    font-size: 12/20rem;
    text-align: center;
    letter-spacing: 0;
    color: #999;
  }
}
</style>
